import React from 'react';
import { UniverseComponent } from 'src/domains/common/universes';
import { observer } from 'src/utils/mobx-react';

export const LoginPageLogo = observer('Logotypes', (): JSX.Element | null => {
    return <UniverseComponent>{(universeModule) => <universeModule.LogotypeLoginPage />}</UniverseComponent>;
});
